// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"7bd5942a","386":"7781f64c","749":"f7654542"}[chunkId] + ".chunk.js";
};